import OperatorCompanies from "../operator/OperatorCompanies";

// Same list as the operators: companies, owners and active services
export default OperatorCompanies;
